import { RefundRequest } from "../../../services/refundService/model";
import { CompositeSpecification } from "../../../utils/Specification";

export class RefundLocked extends CompositeSpecification<RefundRequest>{
    IsSatisfiedBy(candidate: RefundRequest): boolean {
        if(candidate.status==='STARTED' || candidate.status == 'APPROVE' || candidate.status == 'REJECT')
            return false;
        return true;
    }
}